import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';

import {Settings} from '../../settings';

import * as moment from "moment";

import { VacationCalendarPage } from "../vacation-calendar/vacation-calendar";

/**
 * Generated class for the VacationAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-vacation-add',
  templateUrl: 'vacation-add.html',
})
export class VacationAddPage {

  enableManager: boolean = Settings.showManager;

  managerName: string = Settings.managerName;

  additionalPlaceholder: string = Settings.reasonPlaceholderAdditional;
  reasonPlaceholder: string = Settings.reasonPlaceholder;

  manager: any;

  vacationForm: FormGroup;


  requestFromUnformatted: string;
  requestTillUnformatted: string;

  requestFrom: string;
  requestTill: string;

  requestReason: string = '';
  requestSpecialReason: string = '';
  requestType: number;
  requestManager: number;

  vacationTypes: any = Settings.vacationTypes;

  minDateFrom: string = new Date().toISOString();
  minDateTill: string = new Date().toISOString();

  maxDate: any;
  maxFuturePlaning: number = Settings.maxFuturePlaningDays;

  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, public userProvider: UserProvider, public teamappProvider: TeamappProvider, public modalCtrl: ModalController) {

      if(this.enableManager == true) {
          this.loadManager();
      } else {
          this.requestManager = -1
      }

      this.vacationForm = this.formBuilder.group({
          requestFrom: ['', Validators.required],
          requestTill: ['', Validators.required],
          requestType: ['', Validators.required],
          requestSpecialReason: [''],
          requestReason: [''],
          requestManager: [''],
      });
      this.maxDate = moment().add(this.maxFuturePlaning, 'days').toISOString();

  }

  loadManager() {
      this.teamappProvider.http_request('action=get_manager', 'vacation', false).then(data => {
          this.manager = data;
      });
  }

  onRequestFromDateChange() {
      this.minDateTill = this.requestFrom;
      this.requestTill = this.requestFrom;

  }

  formatDate(date: any) {
      return moment(date).format("DD.MM.YYYY");
  }


  openVacationCalendar(type: string) {
    if(type == 'from') {
        let calendarFromModal = this.modalCtrl.create(VacationCalendarPage,{mode: 'start'});
        calendarFromModal.onDidDismiss(data => {
            if(data && data.mode == 'start') {
                this.requestFromUnformatted = data.vacationStart;
                const date = moment(data.vacationStart).format("DD.MM.YYYY");
                this.requestFrom = date;


                if(this.requestTillUnformatted) {
                    let DateA = new Date(this.requestTillUnformatted);
                    let DateB = new Date(this.requestFromUnformatted);
                    if(DateA < DateB) {
                        this.requestTillUnformatted = null;
                        this.requestTill = null;
                    }
                }
            }
        });
        calendarFromModal.present();
    } else if(type == 'till') {
        let calendarTillModal = this.modalCtrl.create(VacationCalendarPage, {mode: 'end', dateFrom: this.requestFromUnformatted});
        calendarTillModal.onDidDismiss(data => {
            if(data && data.mode == 'end') {
                this.requestTillUnformatted = data.vacationEnd;
                const date = moment(data.vacationEnd).format("DD.MM.YYYY");
                this.requestTill = date;
            }
        });
        calendarTillModal.present();
    }
  }

  sendRequest() {
      let dateFrom = moment(this.requestFromUnformatted).format("YYYY-MM-DD HH:mm:ss");
      let dateTill = moment(this.requestTillUnformatted).format("YYYY-MM-DD HH:mm:ss");
      this.teamappProvider.http_request('action=add_vacation&add_from='+dateFrom+'&add_till='+dateTill+'&add_type='+this.requestType+'&add_specialnote='+this.requestSpecialReason+'&add_optionalnote='+this.requestReason+'&add_manager='+this.requestManager, 'vacation', false).then(data => {
          this.navCtrl.pop();
      });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VacationAddPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/vacation-add/vacation-add.ts